import { render, staticRenderFns } from "./famousProducts.vue?vue&type=template&id=391c10d3&scoped=true&"
import script from "./famousProducts.vue?vue&type=script&lang=js&"
export * from "./famousProducts.vue?vue&type=script&lang=js&"
import style0 from "./famousProducts.vue?vue&type=style&index=0&id=391c10d3&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c10d3",
  null
  
)

export default component.exports